/**
 * Resumen del día de la cabecera (GEN-PX-009). Se pide UNA vez al montar la entrada y no bloquea
 * nada: mientras llega, `estado` es 'cargando' y la cabecera ya muestra el saludo. Si falla, 'error'
 * y la cabecera se queda con el saludo sin texto. El kernel decide si regenera o devuelve el guardado.
 */

import { useEffect, useState } from 'react'
import { getResumenDia } from '../../api/client.js'

/** -> { estado: 'cargando' | 'listo' | 'error', datos: respuesta del kernel | null } */
export default function useResumenDia() {
  const [r, setR] = useState({ estado: 'cargando', datos: null })
  useEffect(() => {
    let vivo = true
    // dentro de un then: cualquier fallo al pedirlo (incluso síncrono) acaba en 'error', nunca rompe la entrada
    Promise.resolve().then(() => getResumenDia())
      .then(datos => { if (vivo) setR({ estado: 'listo', datos }) })
      .catch(() => { if (vivo) setR({ estado: 'error', datos: null }) })
    return () => { vivo = false }
  }, [])
  return r
}

/** El saludo y el titular en el h1 del mockup: «Buenos días, Nombre. Hoy tienes…». Sin titular, solo el saludo. */
export function tituloCabecera(saludo, titular) {
  const t = (titular ?? '').trim()
  if (!t) return saludo
  return `${saludo}. ${/[.!?…]$/.test(t) ? t : t + '.'}`
}
